import moment from "moment/moment";
import roundTo from "round-to";
import _ from 'lodash';

const coverageFields = [ 'conditionals', 'elements', 'methods', 'statements' ];


class ReportHelper {

    constructor( report, history = null )
    {
        this.report     = report;
        this.history    = history;
    }


    getReportName( fetchType = 'version' )
    {
        switch( fetchType )
        {
            case 'hash':
                return _.get( this.report, 'data.pkg.hash' );

            case 'date':
                return moment( _.get( this.report, 'data.pkg.committed' ) ).format( 'YYYY-MM-DD hh:mm' );

            default:
            case 'version':
                return _.get( this.report, 'data.pkg.version' );
        }
    }


    getCoverageScore()
    {
        if( !_.get( this.report, `data.coverage` ) )
        {
            return {
                coverage        : null,
                conditionals    : null,
                statements      : null,
                elements        : null,
                methods         : null
            };
        }

        const covBase   = {},
            scores      = [];

        const summedScore = _.reduce(
            coverageFields,
            ( runningTotal, field ) => {
                const fieldTotal = _.get( this.report, `data.coverage.${field}.total`, 1 ),
                    fieldCovered = _.get( this.report, `data.coverage.${field}.covered`, 0 );

                covBase[ field ] = roundTo( fieldCovered / fieldTotal * 100, 1 );

                scores.push( covBase[ field ] );

                return runningTotal + ( fieldCovered / fieldTotal );
            },
            0
        );

        covBase.coverageAvg = roundTo( summedScore / coverageFields.length * 100, 1 );

        covBase.coverage = _.min( scores );

        return covBase;
    }


    forcePlus( val )
    {
        return ( val > 0 ) ? `+${val}` : val;
    }


    getCoverageChange()
    {
        if( ( !this.history ) || ( this.history.length < 2 ) )
        {
            return 'n/a';
        }

        const oldReport = new ReportHelper( this.history[ this.history.length - 2 ] ),
            newValue    = this.getCoverageScore().coverage,
            oldValue    = oldReport.getCoverageScore().coverage;

        const difference = roundTo( ( ( newValue - oldValue ) / oldValue ) * 100, 2 );

        return this.forcePlus( difference ) + '%';
    }


    getChange( field )
    {
        if( ( !this.history ) || ( this.history.length < 2 ) )
        {
            return 'n/a';
        }

        const oldReport = this.history[ this.history.length - 2 ],
            oldValue    = _.get( oldReport, field ),
            newValue    = _.get( this.report, field );

        return this.forcePlus( roundTo( ( ( newValue - oldValue ) / oldValue ) * 100, 2 ) ) + '%';
    }

}


export default ReportHelper;





// WEBPACK FOOTER //
// ./src/lib/report-helper.js